import React, { createContext, useContext, useState, useCallback } from 'react';

const ErrorContext = createContext();

export const ERROR_TYPES = {
  NONE: 'none',
  NETWORK: 'network',
  SERVER: 'server',
};

export const ErrorProvider = ({ children }) => {
  const [errorType, setErrorType] = useState(ERROR_TYPES.NONE);
  const [errorDetails, setErrorDetails] = useState(null);

  const setNetworkError = useCallback(() => {
    setErrorType(ERROR_TYPES.NETWORK);
    setErrorDetails({ message: 'Network connection lost' });
  }, []);

  const setServerError = useCallback((details = {}) => {
    setErrorType(ERROR_TYPES.SERVER);
    setErrorDetails(details);
  }, []);

  const clearError = useCallback(() => {
    setErrorType(ERROR_TYPES.NONE);
    setErrorDetails(null);
  }, []);

  const value = {
    errorType,
    errorDetails,
    setNetworkError,
    setServerError,
    clearError,
    hasError: errorType !== ERROR_TYPES.NONE,
  };

  return (
    <ErrorContext.Provider value={value}>
      <div data-testid="error-provider" className="contents">{children}</div>
    </ErrorContext.Provider>
  );
};

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
};

export default ErrorContext;
